export default __webpack_public_path__ + "static/media/nithinpb.com.bba2ca0b.pdf";